import { useState, useCallback } from 'react';

interface UseChatInputReturn {
  inputValue: string;
  onChangeInput: (value: string) => void;
  resetInput: () => void;
}


export const useChatInput = (): UseChatInputReturn => {
  const [inputValue, setInputValue] = useState('');

  const onChangeInput = useCallback((value: string) => {
    setInputValue(value);
  }, []);

  const resetInput = useCallback(() => {
    setInputValue('');
  }, []);

  return {
    inputValue,
    onChangeInput,
    resetInput,
  };
};

export default useChatInput;